import Vue from 'vue'
import store from '../../store'
// import requset from '../../../static/js/config/Global.js';
const user = {
	state: {
		isChangePassword: localStorage.getItem('isChangePassword'),
		userInfo: JSON.parse(sessionStorage.getItem('userInfo') === "" ? null : sessionStorage.getItem('userInfo')),
    version: localStorage.getItem('version'),
    roterOrgId: '',
		windowSize: '',
		orgInfo: {
			logo: {
				fileUrl: ''
			}
		},
		orgTree: [], //组织树
		watermarkOpacity: JSON.parse(localStorage.getItem('watermarkOpacity') || 0.03),
		//证件类型
		documentTypeList: [{
				value: '0',
				label: '居民身份证'
			},
			{
				value: '1',
				label: '护照'
			},
			{
				value: '8',
				label: '企业营业执照'
			},
			{
				value: 'B',
				label: '港澳居民来往内地通行证'
			},
			{
				value: 'C',
				label: '台湾居民来往大陆通行证'
			},
			{
				value: 'H',
				label: '事业单位法人证书'
			},
			{
				value: 'J',
				label: '社会团体登记证书'
			},
			{
				value: 'N',
				label: '企业统一社会信用代码'
			}
		],
		//合同状态
		contractStatusList: [],
		//按钮权限
		buttomList: [],
		buttomListAjax: false, //是否需要请求获取权限
		//菜单权限
		menuList:JSON.parse(sessionStorage.getItem('menu_List') === "" ? null : sessionStorage.getItem('menu_List')),
    enums: { // 枚举
      sealType: JSON.parse(localStorage.getItem('sealType') || '[]') || [], // 印章类型
      sealShape: JSON.parse(localStorage.getItem('sealShape') || '[]') || [], // 印章形状
      sealStatus: JSON.parse(localStorage.getItem('sealStatus') || '[]') || [], // 印章状态
    },
	},

	mutations: {
    SET_version: (state, version) => {
      state.version = version
      localStorage.setItem('version', version)
    },
		SET_enums: (state, {key, value}) => {
			state.enums[key] = value
		},
    SET_watermarkOpacity: (state, watermarkOpacity) => {
			state.watermarkOpacity = watermarkOpacity
		},
		SET_userInfo: (state, userInfo) => {
			state.userInfo = userInfo
		},
		SET_window_size: (state, windowSize) => {
			state.windowSize = windowSize
		},
		SET_AVATAR: (state, avatar) => {
			state.avatar = avatar
		},
		//设置用户公司信息
		SET_ORGINFO: (state, orgInfo) => {
			state.orgInfo = {
				...orgInfo
			}
		},
		SET_isChangePassword: (state, isChangePassword) => {
			state.isChangePassword = isChangePassword
		},
		SET_contractStatusList: (state, contractStatusList) => {
			state.contractStatusList = contractStatusList
		},
		SET_buttomList: (state, buttomList) => {
			state.buttomList = buttomList
		},
		SET_buttomListAjax: (state, buttomListAjax) => {
			state.buttomListAjax = buttomListAjax
		},
		SET_setRoterOrgId: (state, roterOrgId) => {
			state.roterOrgId = roterOrgId
		},
		SET_orgTree: (state, orgTree) => {
			state.orgTree = orgTree
		},
		SET_menu_List:(state, menuList)=>{
			state.menuList = menuList
			sessionStorage.setItem('menu_List', JSON.stringify(menuList));
		}
	},

	actions: { //异步操作mutation
    set_version({ commit }, version) {
      localStorage.setItem('version', version)
      commit('SET_VERSION', version)
    },
    set_enums({ commit }, {key, value}) {
      commit('SET_enums', {key, value})
      localStorage.setItem(key, JSON.stringify(value))
    },
		//设置菜单权限
		set_menu_List({
			commit
		}, menu) {
			commit('SET_menu_List', menu)
		},
		// 登录
		set_Login_info({
			commit
		}, userInfo) {
			sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
			commit('SET_userInfo', userInfo)
		},
		set_userName({
			commit,
			state
		}, userName) {
			state.userInfo.userName = userName
			sessionStorage.setItem('userInfo', JSON.stringify(state.userInfo));
			commit('SET_userInfo', state.userInfo)
		},
		//监听窗口大小
		set_window_size({
			commit
		}, windowSize) {
			commit('SET_window_size', windowSize)
		},

		SET_watermarkOpacity({
			commit
		}, watermarkOpacity) {
			localStorage.setItem('watermarkOpacity', JSON.stringify(watermarkOpacity));
			commit('SET_watermarkOpacity', watermarkOpacity)
		},


		// 登出
		set_LogOut({
			commit
		}, userInfo) {
			sessionStorage.setItem('userInfo', "");
			// localStorage.clear()
			commit('SET_userInfo', userInfo)
			//设置菜单权限
			commit('SET_menu_List',[])
		},
		//用户公司信息
		set_orgInfo({
			commit
		}, orgInfo) {
			// localStorage.clear()
			localStorage.setItem('orgInfo', JSON.stringify(orgInfo))
			commit('SET_ORGINFO', orgInfo)
		},
		set_isChangePassword({
			commit
		}, isChangePassword) {
			localStorage.setItem('isChangePassword', isChangePassword)
			console.log('vuex密码策略', isChangePassword)
			commit('SET_isChangePassword', isChangePassword)
		},
		//设置合同状态
		set_contractStatusList({
			commit
		}, contractStatusList) {
			commit('SET_contractStatusList', contractStatusList)
		},
		set_buttomList({
			commit
		}, buttomList) {
			commit('SET_buttomList', buttomList)
		},
		//获取用户的按钮权限
		getbuttomList({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				if (state.buttomListAjax == true) {
					return
				}
				state.buttomListAjax = true
				Vue.prototype.GLOBAL.doGet(store.getters.api.GLOBAL_electronic_bank_findButtonList, {})
					.then(res => {
						if (res.code == 200) {
							commit('SET_buttomList',  res.data)
						}
						resolve(res.data)
					}).catch(error => {
						reject(error)
					})
			})
		},
		//获取用户菜单权限
		getRouteList({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				Vue.prototype.GLOBAL.doGet(store.getters.api.GLOBAL_perms_getRoute, {})
					.then(res => {
						if (res.code == 200) {
							commit('SET_menu_List', res.data)
              const version = ((res.version || '').substring(4)) || ''
							commit('SET_version', version)
						}else if(res.code==604){
							sessionStorage.setItem('userInfo', "");
							commit('SET_userInfo', '')
						}
						resolve(res.data)
					}).catch(error => {
						reject(error)
					})
			})
		},
		setButtomListAjax({
			commit
		}, buttomListAjax) {
			commit('SET_buttomListAjax', buttomListAjax)
		},
		setRoterOrgId({
			commit
		}, roterOrgId) {
			commit('SET_setRoterOrgId', roterOrgId)
		},
		getOrgTree({
			commit
		}) {
			Vue.prototype.GLOBAL.doGet(store.getters.api
			.cmy_auth_department_getLevelsByOrgForAddAndUpdateEmployee, {}).then(res => {
				if (res.code == 200 && res.data) {
					commit('SET_orgTree', res.data)
				}
			})
		}
	}
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js